/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import { Form, Input, Select } from 'antd';
// import _ from 'lodash-es';
import { ThemeContext } from 'styled-components';
// 引入ButtonStyled 组件
import { AddSelectMLStyled } from './AddSelectMLStyled';
import { BrandContext } from '@/contexts/ContextProviders';
// import commStyles from '@/comm.less?modules';
import classnames from 'classnames';
const { Option } = Select;
/**
 * select
 * @param {*} param
 */
const SelectML = ({
  labelVal,
  placeVal,
  disabled,
  icon,
  height = '47px',
  labelwidth,
  inputWidth,
  name,
  onSelect,
  required,
  option,
  className = [],
  onChange,
  allowClear,
}) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);

  return (
    <AddSelectMLStyled
      theme={themeContext}
      brand={brandContext}
      inputWidth={inputWidth}
      height={height}
      labelwidth={labelwidth}
    >
      <Form.Item
        colon={false}
        name={name}
        rules={required}
        label={
          <>
            {icon ? icon : ''}
            {labelVal}
          </>
        }
      >
        <Select
          style={{ minWidth: inputWidth, height: height }}
          placeholder={placeVal}
          onSelect={onSelect}
          disabled={disabled}
          onChange={onChange}
          allowClear={allowClear}
          className={classnames(...className)}
        >
          {option.map((item, index) => (
            <Option key={index} value={item.value}>
              {item.name}
            </Option>
            // <Option key={index} value={item.name}>
            //   {item.value}
            // </Option>
          ))}
        </Select>
      </Form.Item>
    </AddSelectMLStyled>
  );
};

export default SelectML;
